import { render } from "./Banner.vue?vue&type=template&id=4c221eac&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=4c221eac&scoped=true&lang=css"

import exportComponent from "D:\\网页文件\\新闻网专题\\2023ZT\\Fzsp\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c221eac"]])

export default __exports__